import React from "react";
import { useStaticQuery, graphql } from "gatsby"
import { storyblokEditable } from "gatsby-source-storyblok";
import { ProcessLink } from "../../global/helpers"

const Svg = ({blok}) => {  

    const svgs = useStaticQuery(
        graphql`
          query {
            allStoryblokEntry(filter: {field_component: {in: ["svg_icon_post"]}}) {
              nodes {
                content
                uuid
                name
              }
            }
          }
        `
    )

    const link = (blok.link.url !== '') ?  ProcessLink(blok.link) : false;
    
    let svg_icon = function(svgs, ID){
        var svg = "";

        for( let i = 0; i < svgs.allStoryblokEntry.nodes.length; i++ ){
            if(svgs.allStoryblokEntry.nodes[i].uuid === ID){
                svg = JSON.parse(svgs.allStoryblokEntry.nodes[i].content).svg_icon
            }
        }  

        return {__html: svg}; 
    }
    return(  
      <div {...storyblokEditable(blok)}  className="icon component svg" key={blok._uid}> 
        {link
          ? <a href={link.url}  target={link.target} aria-label="Icon Link" className={link.cssClass} dangerouslySetInnerHTML={svg_icon(svgs,blok.svg_icon)} />
          : <span dangerouslySetInnerHTML={svg_icon(svgs,blok.svg_icon)} />  
        } 
      </div> 
    )
}

export default Svg;